export function CopyIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='17' height='21' viewBox='0 0 17 21' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M1.5 20.9751C1.1 20.9751 0.75 20.8251 0.45 20.5251C0.15 20.2251 0 19.8751 0 19.4751V4.4001H1.5V19.4751H13.35V20.9751H1.5ZM4.5 17.9751C4.1 17.9751 3.75 17.8251 3.45 17.5251C3.15 17.2251 3 16.8751 3 16.4751V2.4751C3 2.0751 3.15 1.7251 3.45 1.4251C3.75 1.1251 4.1 0.975098 4.5 0.975098H15.5C15.9 0.975098 16.25 1.1251 16.55 1.4251C16.85 1.7251 17 2.0751 17 2.4751V16.4751C17 16.8751 16.85 17.2251 16.55 17.5251C16.25 17.8251 15.9 17.9751 15.5 17.9751H4.5ZM4.5 16.4751H15.5V2.4751H4.5V16.4751Z'
        fill='currentColor'
      />
    </svg>
  )
}
